// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--color-surface, #f3efe6);
  color: var(--color-text-primary, #5c636b);
  font-family: var(--font-family-primary, -apple-system, sans-serif);
}

.legal-page__header {
  padding: var(--spacing-md, 16px) var(--spacing-lg, 24px);
  border-bottom: 1px solid var(--color-border, #e8e3d8);
}

.legal-page__brand {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-primary, #1f2a44);
  text-decoration: none;
}

.legal-page__main {
  flex: 1;
  padding: var(--spacing-xl, 32px) var(--spacing-md, 16px);
}

/* Reading-width column: long-form text, like the Profile/Billing forms. */
.legal-page__article {
  max-width: 760px;
  margin: 0 auto;
  line-height: 1.6;
}

.legal-page__article h1 {
  margin: 0 0 var(--spacing-sm, 8px);
  color: var(--color-primary, #1f2a44);
}

.legal-page__article h2 {
  margin: var(--spacing-xl, 32px) 0 var(--spacing-sm, 8px);
  font-size: 1.2rem;
  color: var(--color-primary, #1f2a44);
}

.legal-page__updated {
  margin: 0;
  font-size: 0.9rem;
}

.legal-page__footer {
  padding: var(--spacing-md, 16px);
  text-align: center;
  border-top: 1px solid var(--color-border, #e8e3d8);
}

.legal-placeholder {
  border: 2px dashed var(--color-accent, #b87333);
  border-radius: var(--border-radius-md, 8px);
  background: rgba(184, 115, 51, 0.06);
  padding: var(--spacing-md, 16px);
}

.legal-placeholder__label {
  margin: 0 0 var(--spacing-xs, 4px);
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-accent, #b87333);
}

.legal-placeholder__body > :first-child { margin-top: 0; }
.legal-placeholder__body > :last-child { margin-bottom: 0; }
`, "",{"version":3,"sources":["webpack://./src/pages/legal/LegalPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,yCAAyC;EACzC,kEAAkE;AACpE;;AAEA;EACE,wDAAwD;EACxD,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,wDAAwD;AAC1D;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,wDAAwD;EACxD,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,0CAA0C,aAAa,EAAE;AACzD,yCAAyC,gBAAgB,EAAE","sourcesContent":[".legal-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--color-surface, #f3efe6);\n  color: var(--color-text-primary, #5c636b);\n  font-family: var(--font-family-primary, -apple-system, sans-serif);\n}\n\n.legal-page__header {\n  padding: var(--spacing-md, 16px) var(--spacing-lg, 24px);\n  border-bottom: 1px solid var(--color-border, #e8e3d8);\n}\n\n.legal-page__brand {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--color-primary, #1f2a44);\n  text-decoration: none;\n}\n\n.legal-page__main {\n  flex: 1;\n  padding: var(--spacing-xl, 32px) var(--spacing-md, 16px);\n}\n\n/* Reading-width column: long-form text, like the Profile/Billing forms. */\n.legal-page__article {\n  max-width: 760px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.legal-page__article h1 {\n  margin: 0 0 var(--spacing-sm, 8px);\n  color: var(--color-primary, #1f2a44);\n}\n\n.legal-page__article h2 {\n  margin: var(--spacing-xl, 32px) 0 var(--spacing-sm, 8px);\n  font-size: 1.2rem;\n  color: var(--color-primary, #1f2a44);\n}\n\n.legal-page__updated {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.legal-page__footer {\n  padding: var(--spacing-md, 16px);\n  text-align: center;\n  border-top: 1px solid var(--color-border, #e8e3d8);\n}\n\n.legal-placeholder {\n  border: 2px dashed var(--color-accent, #b87333);\n  border-radius: var(--border-radius-md, 8px);\n  background: rgba(184, 115, 51, 0.06);\n  padding: var(--spacing-md, 16px);\n}\n\n.legal-placeholder__label {\n  margin: 0 0 var(--spacing-xs, 4px);\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--color-accent, #b87333);\n}\n\n.legal-placeholder__body > :first-child { margin-top: 0; }\n.legal-placeholder__body > :last-child { margin-bottom: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
